import { useCallback } from 'react'
import { Dialogs, useDialogs } from '../Contexts/DialogsContext'
import FullscreenAnimation from '../Dialogs/FullscreenAnimation'

interface UseFullscreenAnimationOptions {
    backdrop?: boolean
}

const useFullscreenAnimation = () => {
    const { registerDialog, unregisterDialog } = useDialogs()

    const showAnimation = useCallback(
        (animationUrl: string, onAnimationEnd?: () => void, options: UseFullscreenAnimationOptions = {}) => {
            const { backdrop = true } = options

            registerDialog(
                Dialogs.FULLSCREEN_ANIMATION,
                <FullscreenAnimation animationUrl={animationUrl} onAnimationEnd={onAnimationEnd} backdrop={backdrop} />,
            )
        },
        [registerDialog],
    )

    const hideAnimation = useCallback(() => {
        unregisterDialog(Dialogs.FULLSCREEN_ANIMATION)
    }, [unregisterDialog])

    return {
        showAnimation,
        hideAnimation,
    }
}

export default useFullscreenAnimation
